import React, {useMemo} from "react";
import {IAssetRequestCount} from "./types/asset-card.types";
import {Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip} from "recharts";
import EmptyData from "../../common/empty-data/empty-data";
import {FolderOpen} from "lucide-react";
import LoadingSkeleton from "../../common/loading-skeleton/loading-skeleton";

interface IAssetChartViewProps {
    assetRequestCount: IAssetRequestCount;
    loading: boolean;
}

const AssetSummaryChart = (props: IAssetChartViewProps) => {


    const PIE_COLORS = [
        'var(--pn-chart-secondary)',
        'var(--pn-chart-primary)',
        'var(--pn-chart-tertiary)',
        'var(--pn-chart-cancelled)',
        'var(--pn-chart-quaternary)'
    ];

    const chartData = useMemo(() => {
        if (!props) return [];

        return [
            {
                name: "Accepted",
                value: props.assetRequestCount.requestAnalysis.summary.accepted,
            },
            {
                name: "Allocated",
                value: props.assetRequestCount.requestAnalysis.summary.allocated,
            },

            {
                name: "Pending",
                value: props.assetRequestCount.requestAnalysis.summary.pending,

            },
            {
                name: "Cancelled",
                value: props.assetRequestCount.requestAnalysis.summary.cancelled,
            },
            {
                name: "Rejected",
                value: props.assetRequestCount.requestAnalysis.summary.rejected,
            },
        ];
    }, [props]);



    return (
        <LoadingSkeleton loading={props.loading}>
            <div className={"dashboard-admin-attendance-card-chart"} >
                {
                    props.assetRequestCount.requestAnalysis.summary.total ?
                        <section>
                            <ResponsiveContainer width="100%" height={200}>
                                <PieChart>
                                    <Pie
                                        data={chartData}
                                        cx="50%"
                                        cy="50%"
                                        innerRadius={55}
                                        outerRadius={80}
                                        paddingAngle={3}
                                        dataKey="value"
                                        nameKey="name"
                                        stroke="none"
                                    >
                                        {chartData.map((_, index) => (
                                            <Cell
                                                key={`cell-${index}`}
                                                fill={PIE_COLORS[index % PIE_COLORS.length]}
                                                stroke="none"
                                            />
                                        ))}
                                    </Pie>

                                    <Tooltip
                                        contentStyle={{
                                            background: '#FFFFFF',
                                            border: '1px solid #e2e8f0',
                                            borderRadius: '8px',
                                            fontSize: '12px',
                                            fontWeight: 600,
                                            color: '#0f172a',
                                        }}
                                    />

                                    <Legend
                                        layout="vertical"
                                        verticalAlign="middle"
                                        align="right"
                                        iconType="circle"
                                        iconSize={10}
                                        formatter={(value, entry: any) => {
                                            return (
                                                <span
                                                    style={{
                                                        color: 'var(--pn-text-primary)',
                                                        fontSize: '13px',
                                                        fontWeight: 500,
                                                    }}
                                                >
                {value} : {entry.payload.value}
            </span>
                                            );
                                        }}
                                    />
                                </PieChart>
                            </ResponsiveContainer>
                        </section> :
                        <EmptyData
                            icon={<FolderOpen className={'asset-request-empty-data-icon'}/>}
                            title={"No Asset Requests Found"}
                            subtitle={"There are currently no asset requests to review or manage."}
                        />
                }
            </div>
        </LoadingSkeleton>

    )
}

export default AssetSummaryChart;
